import { render, staticRenderFns } from "./NewOrderFromTemplate.vue?vue&type=template&id=386a67be&"
import script from "./NewOrderFromTemplate.vue?vue&type=script&lang=js&"
export * from "./NewOrderFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports